import request from '@/utils/request'
// 申请风险金新增
export function addRisk(data) {
    return request({
      url: '/risk',
      method: 'post',
      data
    })
  }
  // 申请风险金详情
  export function getRisk(id) {
    return request({
      url: `/risk/${id}`,
      method: 'get',
    })
  }
  // 申请风险金修改
  export function updateRisk(data) {
    return request({
      url: '/risk',
      method: 'put',
      data
    })
  }
  // 申请风险金删除
export function delRisk(id) {
    return request({
      url: `/risk/${id}`,
      method: 'delete'
    })
  }